import React, { useState, useEffect, useRef } from 'react'
import { Button, Col, Row, Modal, Divider, Skeleton, Spin, Input, Checkbox } from 'antd'
import VirtualList from 'rc-virtual-list'
import { useDispatch, useSelector } from 'react-redux'
import {
  CHART,
  TABLE,
  tableColumnNamesMapping,
  TOTAL
} from '../../constants/contractComparisonConstant'
import ContractHeaderOne from './contractHeaderOne/contractHeaderOne'
import CcGroupButton from './ccGroupButton/ccGroupButton'
import './contractComparison.scss'
import MerckDropdown from '../../shared/merckDropdown/merckDropdown'
import Setting from '../../Assets/Icons/Setting.svg'
import Iicon from '../../Assets/Icons/Iicon.svg'
import TableContractComparison from './tableTab.jsx/TableContractComparison'
import GraphComponent from './graphTab.jsx/GraphComponent'
import DefineWacModal from './contractModal/defineWacModal'
import AlignmentTypeModal from './contractModal/alignmentTypeModal'
import ContractTemplateModal from './contractModal/contractTemplateModal'
import { useMutation } from 'react-query'
import { updateDateSourceAlignments, updateOptionList } from '../../reducer/AlignmentsSlice'
import {
  getDropdownCurrentAlignment,
  getCurrentAlignmentDetails
} from '../../services/currentAlignmentApi'
import { LIST_CHANGE } from '../../constants/alignments'
import { getWacDetails } from '../../services/wacApi'
import { getContractStructureDropdownValue } from '../../services/contractStrutureApi'
import {
  getAccountOrCorporateParentFilter,
  getContractComparision,
  getContractComparisionGraphData,
  pollingContractComparison,
  saveInterimWacPricing
} from '../../services/contractComparison'
import { getSummary } from '../../services/accountSummary'

import {
  updateIsCallSummaryPovRefresh,
  updateIsCCDropdownDownChangeSummary,
  updateselectedAccountSummaryHeaderContractDD,
  updateSendWacAlignmentId,
  updateTriggerGetSummaryForce
} from '../../reducer/accountSummary/accountSummarySlice'
import { updateIsCallPovAPIRefresh } from '../../reducer/customerPov/customerPovSlice'

import { getCustomerPOVData } from '../../services/customerPOV'
import {
  updateContractComparisonWACData,
  updateSelectedContractStructureTemplatesIds,
  updatedDefaultAlignment,
  updateSelectedWACId,
  setIsPolling
} from '../../reducer/contractComparison/contractComparisonSlice'
import { CopyOutlined } from '@ant-design/icons'
import TableGrid from '../../shared/TableGrid/TableGrid'
import CopyContractComparison from './copyContractComparison/CopyContractComparison'
import {
  setIsScenarioChangesDetectedFlag,
  updateSendContractStructureTemplateIdCustomerPov,
  updateSendContractStructureTemplateIdSummary
} from '../../reducer/CommonSlice'
import { useGlobalNotification } from '../../utils/notificationProvider'

const AccountNameFilter = ({
  interimScenarioId,
  accountTypeSelected,
  contractTypeSelected,
  setContractComparisonFilters,
  contractComparisonFilters,
  confirm,
  clearFilters,
  selectedKeys,
  setSelectedKeys
}) => {
  const [page, setPage] = useState(1)
  const [filterData, setFilterData] = useState([])
  const [searchValue, setSearchValue] = useState('')
  const containerRef = useRef()
  const PAGE_SIZE = 12
  const {
    data,
    isLoading,
    mutate: fetchFilterData
  } = useMutation(getAccountOrCorporateParentFilter)

  const fetchData = (newPage = 1) => {
    fetchFilterData(
      {
        model: {
          filters: [],
          list_details: [],
          settings: {
            interim_scenario_id: interimScenarioId,
            account_type: accountTypeSelected,
            contract_type: contractTypeSelected,
            search_keyword: searchValue,
            limit: PAGE_SIZE,
            offset: (newPage - 1) * PAGE_SIZE
          }
        },
        user_id: sessionStorage.getItem('user_id'),
        application_role: sessionStorage.getItem('application_role')
      },
      {
        onSuccess: (res) => {
          const newItems = res?.data?.result?.accounts || []
          setFilterData((prev) => (newPage === 1 ? newItems : [...prev, ...newItems]))
        }
      }
    )
  }

  useEffect(() => {
    setSelectedKeys(contractComparisonFilters)
  }, [])

  useEffect(() => {
    fetchData(page)
  }, [page, searchValue])

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget
    if (scrollHeight - scrollTop <= clientHeight + 50 && !isLoading) {
      setPage((prev) => prev + 1)
    }
  }

  const handleCheckboxChange = (checked, value) => {
    const newSelected = checked
      ? [...selectedKeys, value]
      : selectedKeys.filter((key) => key !== value)
    setSelectedKeys(newSelected)
  }

  const handleSearch = (e) => {
    setPage(1)
    setSearchValue(e.target.value)
  }

  const handleReset = () => {
    setContractComparisonFilters([])
    clearFilters()
    confirm()
  }

  const handleApply = () => {
    setContractComparisonFilters(selectedKeys)
    confirm()
  }

  return (
    <div style={{ minWidth: 300, maxWidth: '100%', display: 'inline-block', padding: 8 }}>
      <Input
        placeholder="Search"
        value={searchValue}
        onChange={handleSearch}
        style={{ marginBottom: 8 }}
        allowClear
      />
      <div
        style={{ border: '1px solid #f0f0f0', borderRadius: 4, maxHeight: 250, overflow: 'auto' }}
      >
        <VirtualList
          data={[
            ...filterData,
            {
              isLoaderElement: true
            }
          ]}
          height={Math.min(filterData.length * 32, 250)}
          itemHeight={32}
          itemKey="value"
          onScroll={handleScroll}
          ref={containerRef}
        >
          {(item) => {
            if (item.isLoaderElement) {
              return isLoading ? <Spin /> : <></>
            }
            const label = item.account_or_corporate_name
            const value = item.account_or_corporate_id
            return (
              <Checkbox
                key={value}
                checked={selectedKeys.includes(value)}
                onChange={(e) => handleCheckboxChange(e.target.checked, value)}
                style={{ width: '100%', padding: '4px 8px', display: 'flex', alignItems: 'center' }}
              >
                <span
                  style={{
                    flex: 1,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                  }}
                >
                  {label}
                </span>
              </Checkbox>
            )
          }}
        </VirtualList>
      </div>
      <Divider style={{ margin: '8px 0' }} />
      <div style={{ textAlign: 'right', display: 'flex', justifyContent: 'space-between' }}>
        <Button
          onClick={handleReset}
          size="small"
          type="text"
          style={{
            marginRight: 8,
            color: '#1677ff',
            border: 'none',
            background: 'none' // no background
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.color = '#69b1ff'
            e.currentTarget.style.background = 'none'
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.color = '#1677ff'
            e.currentTarget.style.background = 'none'
          }}
        >
          Reset
        </Button>
        <Button type="primary" size="small" onClick={handleApply}>
          OK
        </Button>
      </div>
    </div>
  )
}

const ContractComparison = () => {
  const interimScenarioId = useSelector((state) => state.Common.interim_scenario_id)
  const scenario_id = useSelector((state) => state.Common.scenario_id)
  const updatedDefaultAlignmentID = useSelector(
    (state) => state.ContractComparison.updatedDefaultAlignment
  )
  const is_refresh = useSelector((state) => state.Common.is_refresh)
  const contractComparisonWacDataForPaylad = useSelector(
    (state) => state.ContractComparison.contractComparisonWACData
  )
  const selectedContractStructureTemplatesIds = useSelector(
    (state) => state.ContractComparison.selectedContractStructureTemplatesIds
  )
  const selectedWacId = useSelector((state) => state.ContractComparison.selectedWacId)
  const disableFlag = useSelector((state) => state.Common.disableFlag)

  const IsCallPovAPIRefresh = useSelector((state) => state.CustomerPov.isCallPovAPIRefresh)
  const selectedAccountDropdown = useSelector(
    (state) => state.AccountSummary.SelectedAccountSummaryHeaderAccountDD
  )
  const SelectedAccountSummaryHeaderContractDD = useSelector(
    (state) => state.AccountSummary.SelectedAccountSummaryHeaderContractDD
  )
  const isPolling = useSelector((state) => state.ContractComparison.isPolling)

  const accountDefaultValue = useSelector((state) => state.AccountSummary.accountDefaultValue)

  const cstDefaultValue = useSelector((state) => state.AccountSummary.cstDefaultValue)
  const enableBackgroundCalc = useSelector((state) => state.Common.enableBackgroundCalc)

  const [contractComparisonPages, setContractComparisonPages] = useState(0)
  const [contractTemplateSave, setContractTemplateSave] = useState(false)
  const [viewSelected, setViewSelected] = useState(TABLE)
  const [isDefineWacOpen, setIsDefineWacOpen] = useState(false)
  const [currentAlignDetails, setCurrentAlignDetails] = useState([])
  const [currentAlignDropdown, setCurrentAlignDropdown] = useState(null)
  const [contractComparisonOffset, setContractComparisonOffset] = useState(0)

  const [isSelectAllAlignment, setIsSelectAllAlignment] = useState(true)
  const [selectedAlignmentValues, setSelectedAlignmentValues] = useState([])

  const [isAlignmentTypeOpen, setIsAlignmentTypeOpen] = useState(false)
  const [isContractTemplateOpen, setIsContractTemplateOpen] = useState(false)
  const [alignmentTemplateOptions, setAlignmentTemplateOptions] = useState([])
  const [alignmentTemplateValue, setAlignmentTemplateValue] = useState(updatedDefaultAlignmentID)
  //
  const [selectedAlignmentOptions, setSelectedAlignmentOptions] = useState([])
  const [selectedWac, setSelectedWac] = useState(null)
  const [defaultWacOptions, setDefaultWacOptions] = useState([])
  const [contractStructureDetails, setContractStructureDetails] = useState([])
  const [contractTypeDropdownOptions, setContractTypeDropdownOptions] = useState([])
  const [accountTypeDropdownOptions, setAccountTypeDropdownOptions] = useState([])
  const [accountTypeSelected, setAccountTypeSelected] = useState('all')
  const [contractTypeSelected, setContractTypeSelected] = useState('all')
  const [tableGridData, setTableGridData] = useState([])
  const [accountTypeCount, setAccountTypeCount] = useState([])
  const [copyData, setCopyData] = useState([])
  const [grid_data, setGrid_data] = useState([])
  const [sortedCCData, setSorterCC] = useState(null)
  const [filteredCCData, setFilterCC] = useState(null)

  const pushNotification = useGlobalNotification()

  const [triggerSaveInterimWacAPi, setTriggerSaveInterimWacAPi] = useState(false)
  const [contractComparisonFilters, setContractComparisonFilters] = useState([])
  // const [is_summary_povAPI_retriggered, setIs_summary_povAPI_retriggered] = useState(false)

  const [dataSources, setDataSource] = useState([])
  const [columns, setColumns] = useState([])
  const [baseAlignment, setBaseAlignment] = useState(null)
  // const [selectedWacId, setSelectedWacId] = useState(null)
  const contractComparisonWACData = useSelector(
    (state) => state.ContractComparison.contractComparisonWACData
  )
  const isContractComparisonRefresh = useSelector(
    (state) => state.ContractComparison.isContractComparisonRefresh
  )
  const dataSource = useSelector((state) => state.Alignments.dataSourceAlignments)
  const saveData = useSelector((state) => state.Alignments.saveData)
  const optionList = useSelector((state) => state.Alignments.optionList)
  const dispatch = useDispatch()
  const isTriggerGetSummaryRef = useRef(false)
  const wacOrAlignmentChangeRef = useRef(false)
  const {
    isError: isContractStructureDropdownError,
    data: ContractStructureDropdown,
    mutateAsync: mutateContractStructureDropdown
  } = useMutation(getContractStructureDropdownValue)

  const {
    isError: isContractComparisonWACDataError,
    isLoading: isContractComparisonWACDataLoading,
    data: ContractComparisonWACData,
    mutate: mutateContractComparisonWACData
  } = useMutation(getWacDetails)

  const {
    isError: issaveInterimWacPricingError,
    isLoading: issaveInterimWacPricingLoading,
    data: saveInterimWacPricingRespone,
    mutate: mutateSaveInterimWacPricing
  } = useMutation(saveInterimWacPricing)

  const {
    isLoading: pollingContractComparisonLoading,
    data: pollingContractComparisonData,
    mutateAsync: mutatePollingContractComparison
  } = useMutation(pollingContractComparison)

  const {
    isError: isCurrentAlignmentDropdownError,
    isLoading: isCurrentAlignmentDropdownLoading,
    data: CurrentAlignmentDropdown,
    mutate: mutateCurrentAlignmentDropdown
  } = useMutation(getDropdownCurrentAlignment)

  const {
    isError: isCurrentAlignmentDetailsError,
    isLoading: isCurrentAlignmentDetailsLoading,
    data: currentAlignmentDetails,
    mutate: mutateCurrentAlignmentDetails
  } = useMutation(getCurrentAlignmentDetails)

  const {
    isError: isContractComparisonError,
    isLoading: isContractComparisonLoading,
    data: contractComparisonData,
    mutate: mutateContractComparison
  } = useMutation(getContractComparision, {
    onSuccess: (data) => {
      // Enabling force refresh for account summary (getSummary API) in case of contract structure change
      if (isTriggerGetSummaryRef.current) {
        if (!data?.data?.result?.in_progress) {
          isTriggerGetSummaryRef.current = false
          dispatch(updateSendContractStructureTemplateIdSummary(false))
          dispatch(updateSendContractStructureTemplateIdCustomerPov(false))
          dispatch(updateTriggerGetSummaryForce(true))
        }
      }
    }
  })

  const {
    isError: isContractComparisonGraphDataError,
    isLoading: isContractComparisonGraphDataLoading,
    data: contractComparisonGraphData,
    mutate: mutateContractComparisonGraphData
  } = useMutation(getContractComparisionGraphData)

  // const {
  //   isLoading: issummaryGridDataLoading,
  //   data: summaryGridData,
  //   mutate: mutatesummaryGridData,
  // } = useMutation(getSummary);

  const {
    isLoading: isCustomerPOVDataLoading,
    isError: iscustomerPOVDataFetched,
    data: customerPOVDataFetched,
    mutateAsync: mutateCustomerPOVDataFetched
  } = useMutation(getCustomerPOVData)

  // useEffect(() => {
  //   if (viewSelected == CHART) {

  //     mutateContractComparisonGraphData({
  //       model: {
  //         filters: [],
  //         list_details: [],
  //         settings: {
  //           interim_scenario_id: interimScenarioId,
  //           contract_type_contract_structure_template_mapping:
  //             selectedContractStructureTemplatesIds,
  //           wac_type_selected_id: selectedWacId,
  //           alignment_template_id: alignmentTemplateValue,
  //           contract_type: contractTypeSelected,
  //           account_type: accountTypeSelected,
  //         },
  //       },
  //       user_id: sessionStorage.getItem("user_id"),
  //       application_role: sessionStorage.getItem("application_role"),
  //     });
  //   }
  // }, [
  //   viewSelected,
  //   selectedWacId,
  //   alignmentTemplateValue,
  //   selectedContractStructureTemplatesIds,
  //   accountTypeSelected,
  //   contractTypeSelected,
  // ]);

  useEffect(() => {
    setCopyData(dataSources)
  }, [dataSources])

  useEffect(() => {
    mutateContractStructureDropdown({
      model: {
        filters: [],
        list_details: [],
        settings: {
          corporate_parent_id: interimScenarioId
        }
      },
      user_id: sessionStorage.getItem('user_id'),
      application_role: sessionStorage.getItem('application_role')
    })
  }, [isContractComparisonRefresh])

  useEffect(() => {
    if (!isContractStructureDropdownError && ContractStructureDropdown?.data?.result) {
      setContractStructureDetails(
        ContractStructureDropdown?.data?.result.map((data) => ({
          label: data.contract_type,
          value: data.contract_type_id
        }))
      )
    }
  }, [isContractStructureDropdownError, ContractStructureDropdown])

  useEffect(() => {
    if (contractComparisonWACData.length === 0 || isContractComparisonRefresh) {
      mutateContractComparisonWACData(
        {
          model: {
            filters: [],
            list_details: [],
            settings: {
              interim_scenario_id: interimScenarioId
            }
          },
          user_id: sessionStorage.getItem('user_id'),
          application_role: sessionStorage.getItem('application_role')
        },
        {
          onSuccess: () => {},
          onError: (error) => {
            console.error('Error fetching data', error)
          }
        }
      )
    }
  }, [interimScenarioId, isContractComparisonRefresh])

  useEffect(() => {
    if (
      !isContractComparisonWACDataError &&
      !isContractComparisonWACDataLoading &&
      ContractComparisonWACData?.data?.result
    ) {
      const data = ContractComparisonWACData?.data?.result
      const wacDetailsData = data.data
      const wacOptions = data.wac_type
      setDefaultWacOptions(wacOptions)
      if (scenario_id === null || scenario_id) {
        let wacSelected = wacOptions.find((option) => {
          // if (option.selected_flag){
          if (option?.selected_flag && option?.wac_type_id == data?.wac_type_selected_id) {
            return option
          }
          // }
        })
        wacSelected = wacSelected
          ? wacSelected
          : wacOptions.find((it) => it.wac_type_id == data?.wac_type_selected_id)

        setSelectedWac(wacSelected?.wac_type_name || null)
        // console.log('updateSelectedWac called : ', wacSelected)
        dispatch(updateSelectedWACId(wacSelected?.wac_type_id || null))
        dispatch(updateContractComparisonWACData(wacDetailsData))
      }
    }
  }, [ContractComparisonWACData])

  useEffect(() => {
    if (alignmentTemplateValue && interimScenarioId) {
      mutateCurrentAlignmentDetails({
        model: {
          filters: [],
          list_details: [],
          settings: {
            template_id: alignmentTemplateValue,
            interim_scenario_id: interimScenarioId
          }
        },
        user_id: sessionStorage.getItem('user_id'),
        application_role: sessionStorage.getItem('application_role')
      })
    }
  }, [alignmentTemplateValue, isContractComparisonRefresh])

  useEffect(() => {
    if (
      !isCurrentAlignmentDetailsError &&
      !isCurrentAlignmentDetailsLoading &&
      currentAlignmentDetails?.data?.result
    ) {
      setCurrentAlignDetails(currentAlignmentDetails?.data?.result)
    }
  }, [isCurrentAlignmentDetailsError, isCurrentAlignmentDetailsLoading, currentAlignmentDetails])

  useEffect(() => {
    mutateCurrentAlignmentDropdown({
      model: {
        filters: [],
        list_details: [],
        settings: {}
      },
      user_id: sessionStorage.getItem('user_id'),
      application_role: sessionStorage.getItem('application_role')
    })
  }, [isContractComparisonRefresh])

  useEffect(() => {
    if (
      !isCurrentAlignmentDropdownError &&
      !isCurrentAlignmentDropdownLoading &&
      CurrentAlignmentDropdown?.data?.result
    ) {
      setCurrentAlignDropdown(CurrentAlignmentDropdown?.data?.result)
    }
  }, [
    isCurrentAlignmentDropdownError,
    isCurrentAlignmentDropdownLoading,
    currentAlignDropdown,
    CurrentAlignmentDropdown?.data?.result
  ])
  useEffect(() => {
    const alignmentOptionsArray = currentAlignDropdown?.filter(
      (template) => template?.template_id === alignmentTemplateValue
    )?.[0]?.alignment_values

    let optionList = {}
    for (let i = 0; i < alignmentOptionsArray?.length; i++) {
      optionList[alignmentOptionsArray[i].value] = {
        isEdit: false,
        value: alignmentOptionsArray[i].value,
        label: alignmentOptionsArray[i]?.label,
        isVisible: alignmentOptionsArray[i].is_visible,
        editValue: alignmentOptionsArray[i]?.label
      }
    }

    dispatch(updateOptionList({ list: optionList, operationType: `${LIST_CHANGE}` }))
  }, [alignmentTemplateValue, currentAlignDropdown])

  useEffect(() => {
    const atOptions = currentAlignDropdown?.map((item) => {
      return {
        label: item.template_name,
        value: item.template_id
      }
    })

    const defaultATValue = currentAlignDropdown?.findIndex((item) => item.is_default === true)
    setAlignmentTemplateOptions(atOptions)
    // defaultATValue != undefined &&
    //   setAlignmentTemplateValue(
    //     currentAlignDropdown[defaultATValue]?.template_id
    //   );
    // console.log(defaultATValue != undefined &&  currentAlignDropdown[defaultATValue]?.template_id,'kehkanshaa')
    // defaultATValue != undefined &&
    //   dispatch(
    //     updatedDefaultAlignment(
    //       currentAlignDropdown[defaultATValue]?.template_id
    //     )
    //   );
    // setIsDefaultChecked(true);
  }, [currentAlignDropdown])

  const isContractComparisonTemplateSaveCalled = useRef(false)
  useEffect(() => {
    if (isPolling) return
    if (!contractTemplateSave && isContractComparisonTemplateSaveCalled.current) {
      isContractComparisonTemplateSaveCalled.current = false
      return
    }
    if (
      (selectedWacId && alignmentTemplateValue && IsCallPovAPIRefresh && interimScenarioId) ||
      (selectedWacId && alignmentTemplateValue && interimScenarioId)
    ) {
      if (contractTemplateSave) {
        dispatch(updateSendContractStructureTemplateIdCustomerPov(false))
        isContractComparisonTemplateSaveCalled.current = true
      }
      mutateContractComparison(
        {
          model: {
            filters: [],
            list_details: [],
            settings: {
              interim_scenario_id: interimScenarioId,
              scenario_id: scenario_id,
              contract_type_contract_structure_template_mapping:
                selectedContractStructureTemplatesIds,
              wac_type_selected_id: selectedWacId,
              limit: 10,
              offset: contractComparisonOffset * 10,
              account_or_corporate_ids: contractComparisonFilters,
              alignment_template_id: alignmentTemplateValue,
              contract_type: contractTypeSelected,
              account_type: accountTypeSelected
            }
          },
          user_id: sessionStorage.getItem('user_id'),
          application_role: sessionStorage.getItem('application_role')
        },
        {
          onSuccess: (data) => {
            if (data?.data.result?.in_progress) return
            if (viewSelected === CHART) {
              mutateContractComparisonGraphData({
                model: {
                  filters: [],
                  list_details: [],
                  settings: {
                    interim_scenario_id: interimScenarioId,
                    contract_type_contract_structure_template_mapping:
                      selectedContractStructureTemplatesIds,
                    wac_type_selected_id: selectedWacId,
                    alignment_template_id: alignmentTemplateValue,
                    contract_type: contractTypeSelected,
                    account_type: accountTypeSelected
                  }
                },
                user_id: sessionStorage.getItem('user_id'),
                application_role: sessionStorage.getItem('application_role')
              })
            }
            if (wacOrAlignmentChangeRef.current) {
              dispatch(updateSendContractStructureTemplateIdCustomerPov(false))
              dispatch(updateSendContractStructureTemplateIdSummary(false))
              dispatch(updateIsCCDropdownDownChangeSummary(true))
              // dispatch(updateIsCallPovAPIRefresh(true))
              wacOrAlignmentChangeRef.current = false
            }
          }
        }
      )
    }
  }, [
    selectedWacId,
    alignmentTemplateValue,
    contractTemplateSave,
    accountTypeSelected,
    contractTypeSelected,
    viewSelected,
    isContractComparisonRefresh,
    contractComparisonOffset,
    contractComparisonFilters,
    isPolling
  ])

  useEffect(() => {
    let shouldPoll = true

    const poll = async () => {
      if (!isPolling || !shouldPoll) return

      try {
        const data = await mutatePollingContractComparison({
          model: {
            filters: [],
            list_details: [],
            settings: {
              interim_scenario_id: interimScenarioId,
              scenario_id: scenario_id,
              contract_type_contract_structure_template_mapping:
                selectedContractStructureTemplatesIds,
              wac_type_selected_id: selectedWacId,
              alignment_template_id: alignmentTemplateValue
            }
          },
          user_id: sessionStorage.getItem('user_id'),
          application_role: sessionStorage.getItem('application_role')
        })

        if (data?.data?.result) {
          dispatch(setIsPolling(false))
          shouldPoll = false
        } else {
          poll() // Keep polling if not finished
        }
      } catch (error) {
        // Optional: retry or stop polling on error
        poll()
      }
    }

    if (isPolling) {
      poll()
    }

    return () => {
      shouldPoll = false
    }
  }, [isPolling])

  useEffect(() => {
    if (contractComparisonData?.data?.result && contractComparisonData?.data?.result?.in_progress) {
      dispatch(setIsPolling(true))
      return
    } else if (
      !isContractComparisonError &&
      contractComparisonData?.data?.result &&
      !contractComparisonData?.data?.result?.in_progress
    ) {
      setContractComparisonPages(contractComparisonData?.data?.result?.pages_count)
      setContractTemplateSave(false)
      dispatch(
        updateSelectedContractStructureTemplatesIds(
          contractComparisonData?.data?.result.contract_type_contract_structure_template_mapping
        )
      )
      setAccountTypeCount(contractComparisonData?.data?.result.account_type_counts)
      let alignmentOptions = contractComparisonData?.data?.result.alignment_mapping.map((obj) => ({
        ...obj
      }))
      alignmentOptions.unshift({
        label: 'Select All',
        value: 'select_all'
      })
      setSelectedAlignmentOptions(alignmentOptions)

      setContractTypeDropdownOptions([
        { label: 'All', value: 'all' },
        ...contractComparisonData?.data?.result.contract_type_dropdown
      ])
      setAccountTypeDropdownOptions([
        { label: 'All', value: 'all' },
        ...contractComparisonData?.data?.result.account_type_dropdown
      ])
      const values = contractComparisonData?.data?.result.alignment_mapping.map((item) => ({
        ...item
      }))
      setSelectedAlignmentValues(values)
      setTableGridData(contractComparisonData?.data?.result.grid_data)
    }
  }, [contractComparisonData])

  useEffect(() => {
    if (triggerSaveInterimWacAPi) {
      mutateSaveInterimWacPricing({
        model: {
          filters: [],
          list_details: [],
          settings: {
            wac_type_selected_id: selectedWacId,
            interim_scenario_id: interimScenarioId,
            wac_details: contractComparisonWacDataForPaylad
          }
        },
        user_id: sessionStorage.getItem('user_id'),
        application_role: sessionStorage.getItem('application_role')
      })
    }
  }, [triggerSaveInterimWacAPi])

  useEffect(() => {
    if (saveInterimWacPricingRespone?.data?.result) {
      setTriggerSaveInterimWacAPi(false)
    }
  }, [saveInterimWacPricingRespone])

  function transformData(data) {
    return data.map((item) => {
      const newItem = {
        template_id: item.template_id,
        market_id: item.market_id,
        market: item.market,
        cutoff: item.cutoff
      }
      item.alignments.forEach((alignment) => {
        newItem[alignment.alignment_name] = alignment.selected_product_name
      })
      return newItem
    })
  }

  // Transform the data
  const transformedData = transformData(currentAlignDetails)
  useEffect(() => {
    dispatch(
      updateDateSourceAlignments(
        currentAlignDetails?.map((data) => {
          return {
            key: data.market_id,
            market: data.market,
            share_cutoff: data.cutoff
          }
        })
      )
    )
  }, [currentAlignDetails])

  useEffect(() => {
    if (viewSelected == CHART && contractComparisonGraphData) {
      let gridDta = []
      if (contractComparisonGraphData?.data?.result?.result) {
        gridDta = getGridData(contractComparisonGraphData?.data?.result?.result)
      } else if (contractComparisonGraphData?.data?.result?.message) {
        pushNotification(
          'info',
          'No Data Fetched',
          'No Data Available For The Selected Combination',
          3
        )
      } else {
        // && Object.keys(contractComparisonGraphData?.data?.result?.result).length == 0
        pushNotification(
          'error',
          'Data fetch operation failed',
          'Error fetching the data, please try with different combination',
          3
        )
      }

      setGrid_data(gridDta)
    }
  }, [viewSelected, contractComparisonGraphData])

  const getGridData = (data) => {
    let dataKeys = Object.keys(data)
    let nameKey = data[dataKeys[0]]?.map((it) => {
      let name = `${it?.bin_start}_${it?.bin_end}`
      return name
    })
    let gdata = nameKey.map((name) => {
      let obj = {}
      obj.name = name
      dataKeys.forEach((keyss) => {
        let accCount = data[keyss]?.find((it) => {
          if (it.bin_start == name.split('_')[0] && it.bin_end == name.split('_')[1]) {
            return it
          }
        })
        if (accCount) {
          obj[`${keyss}`] = accCount?.account_count
        }
        return obj
      })
      return obj
    })
    return gdata
  }

  const options = []
  for (let i = 10; i < 36; i++) {
    options.push({
      value: i.toString(36) + i,
      label: i.toString(36) + i
    })
  }

  const handleModalCancel = () => {
    setIsDefineWacOpen(false)
    setIsAlignmentTypeOpen(false)
    setIsContractTemplateOpen(false)
  }

  const handleDefineWacSave = () => {
    setTriggerSaveInterimWacAPi(true)
    setIsDefineWacOpen(false)
  }

  const handleAlignmentTypeModalSave = () => {
    setIsAlignmentTypeOpen(false)
  }

  const handleAlignmentsChange = (e, value) => {
    if (e.includes('select_all')) {
      if (!isSelectAllAlignment) {
        let options = selectedAlignmentOptions.filter((it) => it['value'] !== 'select_all')
        setSelectedAlignmentValues(options)
        setIsSelectAllAlignment(true)
      } else {
        setSelectedAlignmentValues([])
        setIsSelectAllAlignment(false)
      }
    } else {
      setSelectedAlignmentValues(value)
      setIsSelectAllAlignment(false)
    }
  }
  const handleContractTemplateModalSave = () => {
    isTriggerGetSummaryRef.current = true
    setAccountTypeSelected('all')
    setContractTypeSelected('all')
    dispatch(updateSendWacAlignmentId(true))
    setContractTemplateSave(true)
    setIsContractTemplateOpen(false)
    dispatch(setIsScenarioChangesDetectedFlag(true))
  }

  const handleDefaultWacChange = (value) => {
    const updatedOptions = defaultWacOptions.map((option) => {
      if (option.wac_type_name === value) {
        dispatch(updateSelectedWACId(option.wac_type_id))
        // setSelectedWacId(option.wac_type_id)
        return { ...option, selected_flag: true }
      } else {
        return { ...option, selected_flag: false }
      }
    })
    setSelectedWac(updatedOptions.find((option) => option.selected_flag)?.wac_type_name || null)
    setDefaultWacOptions(updatedOptions)
    dispatch(setIsScenarioChangesDetectedFlag(true))
  }
  const marketFilters = [...new Set(transformedData.map((item) => item.market))].map((market) => ({
    text: market,
    value: market
  }))
  const columnData = [
    {
      title: <span className="grid-column-header-align">Market</span>,
      dataIndex: 'market',
      editable: false,
      fixed: 'left',
      width: '100px',
      align: 'left',
      filters: marketFilters,
      sorter: (a, b) => a.market?.localeCompare(b.market),
      sortDirections: ['ascend', 'descend', 'ascend'],
      defaultSortOrder: 'ascend',
      onFilter: (value, record) => record.market?.includes(value),
      filterSearch: true
    },
    {
      title: <span className="grid-column-header-align">Share Cut-Off(%)</span>,
      dataIndex: 'cutoff',
      //editable: true,
      fixed: 'left',
      width: '160px',
      align: 'right',
      sorter: (a, b) => a.cutoff - b.cutoff,
      sortDirections: ['ascend', 'descend', 'ascend']
    },
    ...selectedAlignmentValues
      ?.map((it) => {
        const label = optionList[it.value]?.label || ''

        // Check if label is empty or undefined and exclude such items
        if (!label) return null
        return {
          title: <span className="grid-column-header-align">{label}</span>,
          dataIndex: optionList[it.value]?.label,
          align: 'right',
          sorter: (a, b) => {
            const labelA = a?.[optionList[it.value]?.label] || ''
            const labelB = b?.[optionList[it.value]?.label] || ''

            return labelA.localeCompare(labelB)
          }
        }
      })
      .filter(Boolean)
  ]

  //////
  useEffect(() => {
    // console.log("hitted", selectedAlignmentValues)
    const newDataSource = createDataSource()
    const dynamicColumns = generateDynamicColumns(selectedAlignmentValues, tableGridData)

    const newColumns = [
      {
        title: '',
        dataIndex: 'account_name',
        className: 'top-row',
        width: '250px',
        children: [accountColumn]
      },
      ...dynamicColumns
    ]
    setDataSource(newDataSource)
    setColumns(newColumns)
    // dispatch(setColumns(newColumns));
    // dispatch(setDataSource(newDataSource));
  }, [selectedAlignmentValues, selectedAlignmentOptions, tableGridData])

  const createDataSource = () => {
    let baseAlignmentNumber = null

    const formatDollarValue = (value) => {
      return `$${parseFloat(value)
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
    }

    const data = Object.keys(tableGridData).map((key) => {
      const entityData = tableGridData[key]
      const entityDetails = key === 'Total' ? key : key.split('|')

      const reducedData = entityData.reduce((acc, item) => {
        if (item?.alignment_number == 0) {
          acc[`${item?.alignment_number}_aligned_alignment`] = item?.aligned_alignment
          acc[`${item?.alignment_number}_rotateq_share`] =
            key === 'Total'
              ? item?.rotateq_share
              : item?.rotateq_share
                ? parseFloat(item?.rotateq_share)?.toFixed(2)
                : item?.rotateq_share

          acc[`${item?.alignment_number}_mrk_pneumo_dose_share`] =
            key === 'Total'
              ? item?.mrk_pneumo_dose_share
              : `${parseFloat(item?.mrk_pneumo_dose_share)?.toFixed(2)}%`

          acc[`${item?.alignment_number}_mrc_multi_source_gross_sales`] = formatDollarValue(
            item?.mrc_multi_source_gross_sales
          )
          acc[`${item?.alignment_number}_current_nac`] = formatDollarValue(item?.current_nac)
        } else {
          if (item?.is_base_alignment && baseAlignmentNumber === null) {
            baseAlignmentNumber = item?.alignment_number
          }
          acc[`${item?.alignment_number}_ppd_percentage`] =
            key === 'Total'
              ? item?.ppd_percentage
              : `${parseFloat(item?.ppd_percentage)?.toFixed(2)}%`
          acc[`${item?.alignment_number}_ppd_dollar`] = formatDollarValue(item?.ppd_dollar)
          acc[`${item?.alignment_number}_nac`] = formatDollarValue(item?.nac)
        }
        return acc
      }, {})

      return {
        key: key,
        account_name: key === 'Total' ? entityDetails : entityDetails[1],
        entityDetails: entityDetails,
        ...reducedData
      }
    })

    setBaseAlignment(baseAlignmentNumber)
    return data
  }

  // Function to generate account summary table headers

  const generateDynamicColumns = (selectedAlignmentValues, gridData) => {
    const columns = []
    let baseAlignmentColumn = null

    selectedAlignmentValues.forEach((it) => {
      const alignmentInfo = selectedAlignmentOptions.find(
        (item) => item.value === parseInt(it?.value, 10)
      )

      if (alignmentInfo) {
        const title = alignmentInfo.label
        const childData = Object.keys(gridData).flatMap((entityId) => {
          const data = gridData[entityId]
          const alignmentNumber = parseInt(it.value, 10)

          if (data.some((item) => item.alignment_number === alignmentNumber)) {
            return {
              ...data.find((item) => item.alignment_number === alignmentNumber)
            }
          }
          return []
        })

        if (childData.length > 0) {
          const children = Object.keys(childData[0])
            .filter((key) => key !== 'alignment_number')
            .map((key, index) => ({
              title: tableColumnNamesMapping[key],
              dataIndex: `${it?.value}_${key}`,
              key: `${it?.value}_${index}`,
              width: '250px'
            }))
            .filter((column) => column.title !== undefined)
          const column = {
            title: title,
            children: children,
            className: 'top-row'
          }
          if (it?.value === baseAlignment) {
            baseAlignmentColumn = {
              ...column,
              // align: "right",
              className: 'top-row',
              children: column.children.filter((child) => {
                if (child.dataIndex.endsWith('_nac')) {
                  let childs = child
                  childs.fixed = 'right'
                  return childs
                }
              }),
              fixed: 'right'
            }
          } else {
            columns.push(column)
          }
        }
      }
    })

    if (baseAlignmentColumn) {
      columns.push(baseAlignmentColumn)
    }
    if (columns.length > 0) {
      const index = columns?.findIndex((item) => item.title === 'Current State')
      const [currentState] = columns.splice(index, 1)
      columns.unshift(currentState)
    }

    return columns
  }

  useEffect(() => {
    const dynamicColumns = generateDynamicColumns(selectedAlignmentValues, tableGridData)

    const newColumns = [
      {
        title: '',
        dataIndex: 'account_name',
        className: 'top-row',
        width: '200px',
        children: [accountColumn]
      },
      ...dynamicColumns
    ]
    setColumns(newColumns)
    // dispatch(setColumns(newColumns));
  }, [selectedAlignmentValues, selectedAlignmentOptions, tableGridData, baseAlignment])

  useEffect(() => {
    if (selectedAlignmentValues.length === selectedAlignmentOptions.length - 1) {
      setIsSelectAllAlignment(true)
    } else {
      setIsSelectAllAlignment(false)
    }
  }, [selectedAlignmentValues, selectedAlignmentOptions.length])

  const uniqueDetails = [
    ...new Set(
      dataSources.map((record) =>
        record.key === 'Total'
          ? record.entityDetails
          : `${record.entityDetails[1]}|${record.entityDetails[2]}|${record.entityDetails[3]}|${record.entityDetails[4]}`
      )
    )
  ]

  const accountColumn = {
    title: 'Account Name',
    dataIndex: 'account_name',
    key: 'account_name',
    align: 'left',
    width: '250px',
    fixed: 'left',
    filterDropdown: (props) => {
      return (
        <AccountNameFilter
          interimScenarioId={interimScenarioId}
          accountTypeSelected={accountTypeSelected}
          contractTypeSelected={contractTypeSelected}
          setContractComparisonFilters={setContractComparisonFilters}
          contractComparisonFilters={contractComparisonFilters}
          {...props}
        />
      )
    },
    onFilter: (value, record) => {
      return record?.key == 'Total' || record?.entityDetails[0] == value
    },
    render: (text, record) => (
      <div style={{ textAlign: 'right' }}>
        <span>
          {record.key === 'Total'
            ? record.entityDetails
            : `${record.entityDetails[1]}|${record.entityDetails[2]}|${record.entityDetails[3]}|${record.entityDetails[4]}`}
        </span>
        <Divider type="vertical" style={{ height: '100%' }} />
      </div>
    )
  }

  //////
  return (
    <div className="contract-comparison-main-container">
      <Skeleton active loading={isContractComparisonLoading || isPolling} paragraph={{ rows: 8 }}>
        <Row className="contract-comparison-header-One">
          <Col
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}
          >
            {accountTypeCount.map((item, index) => (
              <ContractHeaderOne key={index} label={item.label} count={item.count} />
            ))}
            <CopyContractComparison
              contractTypeSelected={contractTypeSelected}
              alignmentTemplateValue={alignmentTemplateValue}
              contractComparisonFilters={contractComparisonFilters}
              selectedAlignmentValues={selectedAlignmentValues}
              tableGridData={tableGridData}
            />
            <CcGroupButton viewSelected={viewSelected} setViewSelected={setViewSelected} />
          </Col>
        </Row>

        <div className="contract-comparison-header-two">
          <Col style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div className="contract-comparison-dropdown">
              <div className="contract-comparison-text">Define WAC</div>
              <div className="contract-subbox">
                <MerckDropdown
                  options={defaultWacOptions.map((type) => ({
                    value: type.wac_type_name,
                    label: type.wac_type_name,
                    id: type.wac_type_id
                  }))}
                  placeholder="Select.."
                  value={selectedWac}
                  disabled={is_refresh === 'Y' || is_refresh === 'D' || disableFlag}
                  onChange={(value) => {
                    wacOrAlignmentChangeRef.current = true
                    setAccountTypeSelected('all')
                    setContractTypeSelected('all')
                    handleDefaultWacChange(value)
                  }}
                  className="contract-comparison-dropdown-align-d"
                ></MerckDropdown>
                <Button
                  className="contract-comparison-dropdown-align"
                  onClick={() => setIsDefineWacOpen(true)}
                >
                  <img
                    alt={'Icon'}
                    src={Setting}
                    style={{
                      marginLeft: '2px',
                      marginRight: '2px',
                      width: '16px'
                    }}
                  />
                </Button>
              </div>
            </div>
            <div className="contract-comparison-dropdown">
              <div className="contract-comparison-text">Alignment Template</div>
              <div className="contract-subbox">
                <MerckDropdown
                  width={150}
                  options={alignmentTemplateOptions}
                  placeholder="Select.."
                  showSearch={false}
                  allowClear={false}
                  disabled={is_refresh === 'Y' || is_refresh === 'D' || disableFlag}
                  value={alignmentTemplateValue}
                  onChange={(value) => {
                    wacOrAlignmentChangeRef.current = true
                    setAlignmentTemplateValue(value)
                    dispatch(updatedDefaultAlignment(value))
                    setAccountTypeSelected('all')
                    setContractTypeSelected('all')
                    dispatch(setIsScenarioChangesDetectedFlag(true))
                  }}
                  name
                  className="contract-comparison-dropdown-align-d"
                ></MerckDropdown>
                <Button
                  className="contract-comparison-dropdown-align"
                  onClick={() => setIsAlignmentTypeOpen(true)}
                >
                  <img
                    alt={'Icon'}
                    src={Iicon}
                    style={{
                      marginLeft: '2px',
                      marginRight: '2px',
                      width: '15px',
                      height: '15px'
                    }}
                  />
                </Button>
              </div>
            </div>
          </Col>
          <Col style={{ justifyContent: 'space-between' }}>
            <div className="contract-comparison-alignment">
              <div className="contract-comparison-text">Alignments</div>
              <div className="contract-subbox-2">
                <MerckDropdown
                  options={selectedAlignmentOptions}
                  mode={'multiple'}
                  placeholder="Select.."
                  maxTagCount={2}
                  showSearch={false}
                  allowClear={false}
                  value={selectedAlignmentValues}
                  onChange={(e, option) => {
                    handleAlignmentsChange(e, option)
                  }}
                  name
                  className="contract-comparison-multi-dropdown-align"
                  width={250}
                />
                <Button
                  className="contract-comparison-dropdown-align-template-button"
                  onClick={() => setIsContractTemplateOpen(true)}
                  disabled={disableFlag}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    // justifyContent: "space-between",
                    flexWrap: 'nowrap',
                    borderRadius: '0px'
                    // marginLeft: "8px",
                  }}
                >
                  <img
                    alt={'Icon'}
                    src={Setting}
                    style={{
                      marginLeft: '2px',
                      marginRight: '2px',
                      width: '16px'
                    }}
                  />
                  Contract Template
                </Button>
              </div>
            </div>
          </Col>
          <Col
            style={{
              display: 'flex',
              justifyContent: 'space-around',
              gap: '12px'
            }}
          >
            <div className="contract-comparison-dropdown">
              <div className="contract-comparison-text">Contract Type</div>
              <div className="contract-subbox">
                <MerckDropdown
                  options={contractTypeDropdownOptions}
                  width={180}
                  placeholder="Select.."
                  showSearch={false}
                  allowClear={false}
                  value={contractTypeSelected}
                  onChange={(value) => {
                    setContractTypeSelected(value)
                    setContractComparisonOffset(0)
                    setContractComparisonFilters([])
                  }}
                  name
                  className="contract-comparison-dropdown-align-d"
                ></MerckDropdown>
              </div>
            </div>

            <div className="contract-comparison-dropdown">
              <div className="contract-comparison-text">Account Type</div>
              <div className="contract-subbox">
                <MerckDropdown
                  options={accountTypeDropdownOptions}
                  placeholder="Select.."
                  showSearch={false}
                  allowClear={false}
                  value={accountTypeSelected}
                  onChange={(value) => {
                    setAccountTypeSelected(value)
                    setContractComparisonOffset(0)
                    setContractComparisonFilters([])
                  }}
                  name
                  className="contract-comparison-dropdown-align-d"
                  width={180}
                ></MerckDropdown>
              </div>
            </div>
          </Col>
        </div>
        <div className="content-container">
          {viewSelected === TABLE && (
            // <TableContractComparison
            //   selectedAlignmentOptions={selectedAlignmentOptions}
            //   selectedAlignmentValues={selectedAlignmentValues}
            //   tableGridData={tableGridData}

            // />
            <div className="contract-comparison-table">
              <TableGrid
                columnsConfig={columns}
                dataSource={dataSources}
                bordered
                pagination={{
                  current: contractComparisonOffset + 1,
                  pageSize: 11,
                  total: contractComparisonPages * 11,
                  onChange: (page) => {
                    setContractComparisonOffset(page - 1)
                  },
                  showSizeChanger: false
                }}
                scroll1={{ x: 2800 }}
                onChange={(pagination, filters, sorter, extra) => {
                  setContractComparisonOffset(pagination.current - 1)
                  setCopyData(extra.currentDataSource)
                  setSorterCC(sorter)
                  setFilterCC(filters)
                }}
              />
            </div>
          )}
          {viewSelected === CHART && (
            <Skeleton active loading={isContractComparisonGraphDataLoading} paragraph={{ rows: 8 }}>
              <GraphComponent data={grid_data} />
            </Skeleton>
          )}

          {/* }  */}
        </div>
        <DefineWacModal
          isVisible={isDefineWacOpen}
          handleCancel={handleModalCancel}
          handleSave={handleDefineWacSave}
        />
        <AlignmentTypeModal
          isVisible={isAlignmentTypeOpen}
          handleCancel={handleModalCancel}
          columnData={columnData}
          transformedData={transformedData}
        />
        <ContractTemplateModal
          isVisible={isContractTemplateOpen}
          handleCancel={handleModalCancel}
          handleSave={handleContractTemplateModalSave}
          isContractStructureDropdownError={isContractStructureDropdownError}
          ContractStructureDropdown={ContractStructureDropdown}
        />
      </Skeleton>
    </div>
  )
}

export default ContractComparison
